import { desktop, tablet } from '../../theme'


export default {
  container: {
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    paddingTop: '6.4rem',
    ...desktop({
      paddingTop: '8rem',
    }),
  },
  searchBlock: {
    marginTop: '-10rem',
    marginBottom: '-24rem',
    ...tablet({
      marginBottom: '-15rem',
    }),
  },
  afterSearch: {
    paddingTop: '28rem',
    ...tablet({
      paddingTop: '17.4rem',
    }),
  },
}
